<template>
  <div class="bg-zt-light/35 rounded-zt py-2 px-3 border border-zt-light" v-html="content">
  </div>
</template>

<script>
export default {
  name: 'InvisibleBox',
  data() {
    return {
      content: window[`invisible_box_content_${this.$attrs.uuid}`],
    }
  }
};
</script>

<style scoped>
:deep(h2) {
  @apply mt-0 !important;
}
:deep(p) {
  @apply break-words tracking-[0.03em] font-light leading-[27px];
  @apply max-xl:text-left !important;
}
</style>